'use es6';

import PortalIdParser from 'PortalIdParser';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { PlayerMessageTypes } from '../../constants/video';
import { getEmbedIframeDomain, getEmbedIframeUrl, stringifyQueryParams } from '../../utils/video';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "VideoPlayer__StyledWrapper",
  componentId: "zr1zqq-0"
})(["background-color:black;line-height:0;"]);
const StyledIframe = styled.iframe.withConfig({
  displayName: "VideoPlayer__StyledIframe",
  componentId: "zr1zqq-1"
})(["width:100%;border:0 none;"]);
const VideoPlayer = ({
  portalId = PortalIdParser.get(),
  video = {},
  maxHeight,
  conversionAsset,
  hiddenControls,
  currentTime
}) => {
  const iframeRef = useRef(null);
  const hashParams = {
    hsvid: 'rich-text-lib-preview',
    conversionAsset: JSON.stringify(conversionAsset)
  };
  const iframeSrc = `${getEmbedIframeUrl(portalId, video.videoId, {
    parentOrigin: window.location.origin,
    renderContext: 'rich-text-lib'
  })}#${stringifyQueryParams(hashParams)}`;
  useEffect(() => {
    if (iframeRef.current && currentTime) {
      iframeRef.current.contentWindow.postMessage({
        type: PlayerMessageTypes.SET_CURRENT_TIME,
        currentTime
      }, getEmbedIframeDomain());
    }
  }, [currentTime]);
  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage({
        type: PlayerMessageTypes.UPDATE_DISPLAY_OPTIONS,
        payload: {
          hiddenControls,
          conversionAsset
        }
      }, getEmbedIframeDomain());
    }
  }, [hiddenControls, conversionAsset]);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledWrapper, {
      children: /*#__PURE__*/_jsx(StyledIframe, {
        ref: iframeRef,
        src: iframeSrc,
        height: maxHeight,
        referrerPolicy: "origin",
        sandbox: "allow-forms allow-scripts allow-same-origin allow-popups",
        allow: "fullscreen;"
      })
    })
  );
};
VideoPlayer.propTypes = {
  id: PropTypes.number,
  portalId: PropTypes.number,
  video: PropTypes.object,
  maxHeight: PropTypes.number,
  conversionAsset: PropTypes.object,
  currentTime: PropTypes.number,
  hiddenControls: PropTypes.bool
};
export default VideoPlayer;